module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    class: {
      loading: _vm.isLoading
    },
    attrs: {
      "id": "buy-browse"
    }
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Browse")]), _vm._v(" "), _c('aside', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.sets), function(s) {
    return _c('li', [_c('router-link', {
      class: {
        'is-active': _vm.$route.params.id === s.uuid
      },
      attrs: {
        "to": {
          name: 'ViewCategory',
          params: {
            id: s.uuid
          }
        }
      }
    }, [_vm._v(_vm._s(s.name))])], 1)
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf22e056"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BuyBrowse.vue
// module id = 504
// module chunks = 1